import { Loader, Placeholder } from "rsuite";

const LoaderComponent = () => (
  <div>
    <Placeholder.Paragraph rows={8} />
    <Loader backdrop content="loading..." vertical />
  </div>
);

export default LoaderComponent;
